import { create } from 'zustand';

interface INetworkErrorStore {
  networkError: boolean;
  setNetworkError: (error: boolean) => void;
}

export const useNetworkErrorStore = create<INetworkErrorStore>((set) => ({
  networkError: false,

  setNetworkError: (error) => set(() => ({ networkError: error })),
}));
